import { render, staticRenderFns } from "./OrganisationList.vue?vue&type=template&id=3c6c76fd&scoped=true&"
import script from "./OrganisationList.vue?vue&type=script&lang=js&"
export * from "./OrganisationList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/modules/_organisation-list.scss?vue&type=style&index=0&id=3c6c76fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6c76fd",
  null
  
)

export default component.exports